export default __webpack_public_path__ + "static/media/image-coming-soon.9ab69b73.jpg";